function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lan_l") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bg"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1259.5 398.85 1145.12 720 149.78 720 73.66 529.7 20.5 419.29 40.95 149.41 81.84 112.61 98.12 0 1112.56 0 1259.5 398.85",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.04 0 170.44 31.28 184.07 0 203.04 0",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "786.53 678.27 790.32 720 425.33 720 410.33 599.21 573.89 599.21 693.84 558.32 786.53 678.27",
    style: {
      fill: "#cbcbcb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "984.83 720 790.32 720 786.53 678.27 971.9 571.95 984.83 720",
    style: {
      fill: "#cacaca"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1179.08 531.06 1120.04 720 1076.9 720 1097.3 495.62 1179.08 531.06",
    style: {
      fill: "#cecece"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1259.5 398.85 1145.12 720 1120.04 720 1179.08 531.06 1259.5 398.85",
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1097.3 495.62 1076.9 720 984.83 720 971.9 571.95 1097.3 495.62",
    style: {
      fill: "#cdcdcd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.33 720 266.44 720 252.27 680.07 186.79 495.62 410.33 599.21 425.33 720",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.44 720 236.28 720 252.27 680.07 266.44 720",
    style: {
      fill: "#c9c9c9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.27 680.07 236.28 720 196.39 720 121.37 523.79 132.27 476.54 186.79 495.62 252.27 680.07",
    style: {
      fill: "#d0d0d0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.37 523.79 196.84 720 149.78 720 73.66 529.7 20.5 419.29 74.11 495.62 121.37 523.79",
    style: {
      fill: "#d3d3d3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "693.84 558.32 573.89 599.21 410.33 599.21 457.58 476.54 601.15 476.54 646.59 495.62 693.84 558.32",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1097.3 495.62 971.9 571.95 882.85 398.85 855.59 31.28 871.48 0 986.45 0 1097.3 495.62",
    style: {
      fill: "#e7e7e7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1259.5 398.85 1179.08 531.06 1097.3 495.62 986.45 0 1112.56 0 1259.5 398.85",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "601.15 476.54 607.97 437.01 646.59 495.62 601.15 476.54",
    style: {
      fill: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "882.85 398.85 816.51 349.85 670.67 58.09 687.67 0 836.59 0 855.59 31.28 882.85 398.85",
    style: {
      fill: "#e3e3e3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "607.97 437.01 516.65 186.21 467.58 377.04 457.58 476.54 601.15 476.54 607.97 437.01",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.67 58.09 526.19 135.78 816.51 349.85 670.67 58.09",
    style: {
      fill: "#dfdfdf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "971.9 571.95 882.85 398.85 816.51 349.85 526.19 135.78 516.65 186.21 607.97 437.01 646.59 495.62 786.53 678.27 971.9 571.95",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "526.19 135.78 500.29 85.35 477.12 116.7 516.65 186.21 526.19 135.78",
    style: {
      fill: "#dedede"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.79 495.62 287.66 392.03 457.58 476.54 410.33 599.21 186.79 495.62",
    style: {
      fill: "#d5d5d5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.58 476.54 287.66 392.03 332.64 353.93 441.68 398.85 457.58 476.54",
    style: {
      fill: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "871.48 0 855.59 31.28 853.72 0 871.48 0",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "563.82 0 526.19 135.78 500.29 85.35 520.56 0 563.82 0",
    style: {
      fill: "#e3e3e3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.58 476.54 441.68 398.85 516.65 186.21 467.58 377.04 457.58 476.54",
    style: {
      fill: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.12 116.7 463.49 135.78 481.19 286.78 516.65 186.21 477.12 116.7",
    style: {
      fill: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.68 398.85 481.19 286.78 463.49 135.78 357.17 244.82 332.64 353.93 441.68 398.85",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.27 476.54 155.44 428.83 186.79 495.62 132.27 476.54",
    style: {
      fill: "#d2d2d2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "563.82 0 687.67 0 670.67 58.09 526.19 135.78 563.82 0",
    style: {
      fill: "#ececec"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "855.59 31.28 836.59 0 853.72 0 855.59 31.28",
    style: {
      fill: "#ececec"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.5 419.29 45.04 276.63 99.56 234.83 132.27 367.5 132.27 476.54 121.37 523.79 74.11 495.62 20.5 419.29",
    style: {
      fill: "#d7d7d7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.17 244.82 266.76 186.21 223.14 116.7 132.27 367.5 132.27 476.54 155.44 428.83 186.79 495.62 287.66 392.03 332.64 353.93 357.17 244.82",
    style: {
      fill: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.04 276.63 65.03 203.97 170.44 31.28 223.14 116.7 132.27 367.5 99.56 234.83 45.04 276.63",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.84 112.61 170.44 31.28 65.03 203.97 45.04 276.63 20.5 419.29 40.95 149.41 81.84 112.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.44 31.28 81.84 112.61 98.12 0 165.65 0 170.44 31.28",
    style: {
      fill: "#e9e9e9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.07 0 170.44 31.28 165.65 0 184.07 0",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "520.56 0 500.29 85.35 477.12 116.7 463.49 135.78 357.17 244.82 266.76 186.21 307.23 0 520.56 0",
    style: {
      fill: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.78 0 266.76 186.21 170.44 31.28 203.04 0 291.78 0",
    style: {
      fill: "#e2e2e2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.23 0 266.76 186.21 291.78 0 307.23 0",
    style: {
      fill: "#e4e4e4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    style: {
      fill: "none"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanL);
export default __webpack_public_path__ + "static/media/lan_l.899e06f02406530b49f0076363b3d204.svg";
export { ForwardRef as ReactComponent };